import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
    Modal
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import { closeFailedPayoutOrRefundModal } from '../../../actions/modalActions';
import messages from '../../../locale/messages';

import FailedPayoutOrRefundForm from './FailedPayoutOrRefundForm/FailedPayoutOrRefundForm';
import s from './FailedPayoutOrRefundModal.css';

class FailedPayoutOrRefundModal extends Component {

    render() {
        const { closeFailedPayoutOrRefundModal, reservationId, isFailedPayoutOrRefundOpen, type } = this.props;

        return (
            <div>
                <Modal
                    show={isFailedPayoutOrRefundOpen}
                    animation={false}
                    onHide={closeFailedPayoutOrRefundModal}
                    dialogClassName={cx(s.logInModalContainer, 'adminModal')}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {type === 'payout' ? <FormattedMessage {...messages.failedPayoutTab} /> : <FormattedMessage {...messages.failedRefundTab} />}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body bsClass={s.paddingNone} >
                        <div className={cx(s.modalPadding, s.modalBorderBottom)}>
                        <FailedPayoutOrRefundForm id={reservationId} type={type} />
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}


const mapState = state => ({
    isFailedPayoutOrRefundOpen: state.modalStatus.isFailedPayoutOrRefundOpen,
    reservationId: state.modalStatus.reservationId,
    type: state.modalStatus.type
});

const mapDispatch = {
    closeFailedPayoutOrRefundModal,
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(FailedPayoutOrRefundModal)));